var map = {
	"./en": [
		"/WL+",
		3
	],
	"./en.json": [
		"/WL+",
		3
	],
	"./es": [
		"l4qE",
		2
	],
	"./es.json": [
		"l4qE",
		2
	],
	"./pt-br": [
		"sLmE",
		1
	],
	"./pt-br.json": [
		"sLmE",
		1
	],
	"./zh-CN": [
		"Y5Kn",
		0
	],
	"./zh-CN.json": [
		"Y5Kn",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "KYPc";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/lang lazy ^\.\/.*$
// module id = KYPc
// module chunks = 46